var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.25,
    stroke: "#403B37",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5136 9C12.5136 11.3995 12.0514 13.5352 11.3372 15.0429C10.5959 16.6078 9.71916 17.25 9.00046 17.25C8.28177 17.25 7.40505 16.6078 6.66376 15.0429C5.94957 13.5352 5.4873 11.3995 5.4873 9C5.4873 6.60047 5.94957 4.46484 6.66376 2.9571C7.40505 1.39216 8.28177 0.75 9.00046 0.75C9.71916 0.75 10.5959 1.39216 11.3372 2.9571C12.0514 4.46484 12.5136 6.60047 12.5136 9Z",
    stroke: "#403B37",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.108398 9.43359H17.8915",
    stroke: "#403B37",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.8ec87f641fd618a61ba5f97f9069bc3d.svg";
export { ForwardRef as ReactComponent };